import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";

export interface SearchFilters {
  q: string;
  entity_type?: "objective" | "key_result";
  cursor?: string;
  limit?: number;
}

export function useSearch(filters: SearchFilters) {
  return useQuery({
    queryKey: ["search", filters],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/search", {
        params: { query: filters },
      });
      if (error) throw new Error(error.error.message);
      return data;
    },
    enabled: filters.q.length > 0,
  });
}
